module.exports = __webpack_public_path__ + "img/logo.cc619c8b.png";